import { createVuetify } from "vuetify";
import { VApp } from "vuetify/components/VApp";
import { VIcon } from "vuetify/components/VIcon";
import { VSlider } from "vuetify/components/VSlider";
import { VDataTable, VDataTableServer } from "vuetify/components/VDataTable";
import DataTable from "./components/DataTable.vue";
import DataTableServer from "./components/DataTableServer.vue";
import DataTableCell from "./components/DataTableCell.vue";
import DataTableList from "./components/DataTableList.vue";
import Slider from "./components/Slider.vue";
import "./vuetify-labs.css";
//https://stackoverflow.com/questions/73836748/when-will-vuetify-3-0-beta-support-v-data-table
//https://github.com/vuetifyjs/vuetify/discussions/14988
const vuetifyPlugin = {
  install(app) {
    app.component("DataTableCell", DataTableCell);
    app.component("DataTableList", DataTableList);
    app.component("DataTable", DataTable);
    app.component("DataTableServer", DataTableServer);
    app.component("BaseSlider", Slider);
    const vuetify = createVuetify({
      theme: false,
      components: { VDataTableServer, VDataTable, VSlider, VApp, VIcon },
    });
    app.use(vuetify);
  },
};

export { vuetifyPlugin };
